import {Component, OnInit} from '@angular/core';
import {UserService} from "../../services/user.service";
import {NotificationsService} from "angular2-notifications";
import { environment } from "../../../environments/environment";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
    adminList={
        name:''
    };
    companyWalletsList: Array<any>;
    admindetails = {
        _id: ''
    }

    constructor(public auth: UserService, private notifSer: NotificationsService,
                ) {
    }
    envcheck:any;
    colordiff:any;
    ngOnInit() {
        this.envcheck=environment.name;
        if(this.envcheck === 'local'){
          this.colordiff='top-menu-secondary with-overflow color-scheme-dark '
        }else if (this.envcheck === 'test'){
          this.colordiff='top-menu-secondary with-overflow color-scheme-dark'
        }else if(this.envcheck === 'prod'){
          this.colordiff='top-menu-secondary with-overflow color-scheme-dark test'
        }else{
    
        }
        this.admindetails = this.auth.getUserDetails();
        this.getadmin();
    }

    getadmin() {
        this.auth.getAdminProfileById(this.admindetails._id).subscribe(done => {
            this.adminList = done;
        }, (err) => {
            this.notifSer.error(
                'Error',
                'Could not find Admin Detail',
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
            this.auth.logout();
        })
    }

    isEmptyObject(obj) {
        return (obj && (Object.keys(obj).length === 0));
    }

    isUndefinedObject(obj) {
        return (typeof obj === 'undefined');
    }
}



// WEBPACK FOOTER //
// ./src/app/_layout/header/header.component.ts